import { z } from 'zod';
import { UserDTO } from './auth.js';

export const ChangePasswordInput = z.object({
  currentPassword: z.string().min(1).max(200),
  newPassword: z.string().min(8).max(200),
});
export type ChangePasswordInput = z.infer<typeof ChangePasswordInput>;

export const UpdateProfileInput = z.object({
  firstName: z.string().trim().min(1).max(80).nullable().optional(),
  lastName: z.string().trim().min(1).max(80).nullable().optional(),
  email: z.string().email().optional(),
});
export type UpdateProfileInput = z.infer<typeof UpdateProfileInput>;

export const DeleteAccountInput = z.object({
  currentPassword: z.string().min(1).max(200),
});
export type DeleteAccountInput = z.infer<typeof DeleteAccountInput>;

export const MeUpdateResponse = z.object({ user: UserDTO });
export type MeUpdateResponse = z.infer<typeof MeUpdateResponse>;
